module.exports = __webpack_public_path__ + "media/images/sprite/ico-twitter-1f182413035436271a07c48d21cd6d7c.png";